import {
    getAssessmentSchedule,
    updateAssessmentSchedule
} from "./api";
import { RegularGoingOut } from "../../../../domain/assessment/RegularGoingOut";
import { RegularVisit } from "../../../../domain/assessment/RegularVisit";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../../app/funcs/orderResultToast";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Assessment/Schedule",
    get: "get",
    update: "update",
    init: "init"
});

export const getAssessmentScheduleAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.get}`,
    async (careRecipientId: CareRecipientId, { rejectWithValue }) => {
        const response = await getAssessmentSchedule(careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const updateAssessmentScheduleAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.update}`,
    async (data: {
        careRecipientId: CareRecipientId,
        regularGoingOut: RegularGoingOut[],
        regularVisit: RegularVisit[],    
    }, { rejectWithValue }) => {
        const response = await updateAssessmentSchedule(
            data.careRecipientId,
            data.regularGoingOut,
            data.regularVisit
        );

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("予定を更新しました");
            return {};
        } else {
            // API処理結果異常の場合
            orderErrorToast("予定の更新に失敗しました");
            return rejectWithValue({});
        }
    }
);

export const initAssessmentScheduleAction = createAction(
    `${ActionType.base}/${ActionType.init}`
);
